import { useState } from "react";
import { saveBudgetMasterDetails } from "../Api/BudgetMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
// import Dashboard from "../Components/Dashboard";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const BudgetMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  // Company options for dropdown
  const companyOptions = [
    { value: "1000", label: "1000 - STPL" },
    { value: "2000", label: "2000 - BizFlow" },
    { value: "3000", label: "3000 - Discovery Wines" }
  ];

  const [budgetData, setBudgetData] = useState({
    BudgetCode: "",
    BudgetName: "",
    CompanyCode: "",
    BudgetStatus: "",
  });

  const handleChange = (e) => {
    setBudgetData({ ...budgetData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveBudgetMasterDetails(budgetData, userId);
      toast.success(`🦄 Budget Master Added Successfully`);
      setBudgetData({
        BudgetCode: "",
        BudgetName: "",
        CompanyCode: "",
        BudgetStatus: "",
      });
      navigate("/budgetMaster");
    } catch (error) {
      toast.error(`🦄 Error saving Budget Master: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (

    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Budget Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Budget Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="BudgetCode"
                    value={budgetData.BudgetCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Budget Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="BudgetName"
                    value={budgetData.BudgetName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Company Code <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="CompanyCode"
                    value={budgetData.CompanyCode}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Company</option>
                    {companyOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Budget Status <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="BudgetStatus"
                    value={budgetData.BudgetStatus}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Budget Master"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default BudgetMaster;